import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchSimplifiedProducts } from '../../actions/products_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import PurchasePivotChartSearchProd from '../../components/Purchase/purchasePivotChartSearchProd';

let purchasePivotChartSearchProd = reduxForm({
  form: 'purchasePivotChartSearchProd',
})(PurchasePivotChartSearchProd);

const selector = formValueSelector('purchasePivotChartSearchProd');

function mapStateToProps(state) {
    const searchType = selector(state, 'SearchType');
    const searchValue = selector(state, 'SearchValue');
    return {
      searchType,
      searchValue,
      simplifiedProducts: state.products.simplifiedProducts,
      simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
      simplifiedProductsError: state.products.simplifiedProductsError,
    };
}

export default connect(mapStateToProps, { fetchSimplifiedProducts, setDefaultOfForm })(purchasePivotChartSearchProd);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasePivotChartSearchProd.jsx